import { render, staticRenderFns } from "./ParentView.vue?vue&type=template&id=9778b984"
import script from "./ParentView.vue?vue&type=script&lang=js"
export * from "./ParentView.vue?vue&type=script&lang=js"
import style0 from "./ParentView.vue?vue&type=style&index=0&id=9778b984&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports